"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiselectDropdownWidget = void 0;
var tslib_1 = require("tslib");
var Localize_1 = require("../../../gen-src/Localize");
var SelectDropdown_1 = require("./SelectDropdown");
/**
 * Items are toggled using the ENTER key. (Also the SPACE key when using a plain `List`.)
 * Unlike `SingleSelectDropdown`, the popup is not automatically closed on item selection.
 * The popup can be closed by pressing ESC, or by pressing TAB, or by clicking outside of the popup.
 */
var MultiselectDropdownWidget = /** @class */ (function (_super) {
    tslib_1.__extends(MultiselectDropdownWidget, _super);
    function MultiselectDropdownWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiselectDropdownWidget.prototype.makeListProps = function () {
        return {
            onSelect: this.props.onChange,
            onSelectAll: this.props.onSelectAll,
            selectOnEnterKey: true,
            selectedValue: undefined,
            selectedValues: this.props.value,
        };
    };
    MultiselectDropdownWidget.prototype.renderButtonContent = function () {
        var _a, _b, _c;
        var _d = this.props, children = _d.children, items = _d.list.props.items, selectedValues = _d.value;
        if (!(selectedValues instanceof Set) || selectedValues.size < 1 || children) {
            return children !== null && children !== void 0 ? children : '';
        }
        if (selectedValues.size > 1) {
            return Localize_1.Messages.optionsSelected({ COUNT: selectedValues.size.toString() });
        }
        var selectedValue = selectedValues.values().next().value;
        return (_c = (_b = (_a = items.find(function (item) { return item.value === selectedValue; })) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : selectedValue) !== null && _c !== void 0 ? _c : '';
    };
    return MultiselectDropdownWidget;
}(SelectDropdown_1.SelectDropdown));
exports.MultiselectDropdownWidget = MultiselectDropdownWidget;
//# sourceMappingURL=MultiselectDropdownWidget.js.map